<template>
  <div class="login">
    <div class="login_panel">
       <i class="login_panel_close cursor" @click="closeLoginPanel"></i>
       <nav>
         <p class="nav-line"></p>
         <p class="nav-fonts">登录</p>
       </nav>
       <section class="login_content">
            <!--手机登录-->
            <div class="login_tophone">
                <div class="login_input marginTop17" :class="errorPhone? 'inputError':'inputNormal'">
                     <span class="icon_phone"></span>
                     <input type="text" placeholder="请输入您的手机号"  @blur="removeBorder('phone')" aria-placeholder="请输入您的手机号" v-model="phoneNumber" maxlength="11">
                </div>
                <div class="login_input2 marginTop20 clearfix">
                    <div class="inputs" :class="errorPic? 'inputError':'inputNormal'">
                      <span :class="verImgCode?'icon_pass':'icon_nopass'"></span>
                      <input type="text" placeholder="图形验证码"  @blur="removeBorder('pic')" aria-placeholder="图形验证码" v-model="imgCode" maxlength="4" >
                    </div>
                    <img class="code_img code_inputs cursor" :src="imgVerify" alt="" @click="getVerifyImg">
                </div>
                <div class="login_input2 marginTop20 clearfix">
                      <div class="inputs" :class="errorMsg? 'inputError':'inputNormal'">
                        <span :class="verMsgCode?'icon_pass':'icon_nopass'"></span>
                        <input type="text" placeholder="短信验证码" @blur="removeBorder('msg')" aria-placeholder="短信验证码" v-model="msgcode" maxlength="4">
                      </div>   
                     <i class="msg_code code_inputs cursor" @click="getMsgCodes(1)">{{ countTimeName }}</i>
                </div>
                <div class="login_loginbtn marginTop22 cursor" @click="toLogin">登录</div>
                <div class="login_otherway marginTop22">
                   <div class="other_way_line marginTop30">
                      <i class="line"></i>
                      <i class="name">其他登录方式</i>
                      <i class="line"></i>
                   </div>
                   <div class="other_way marginTop19">
                      <p class="cursor"><i class="icon_qq" @click="qqLogins"></i></p>
                      <p class="cursor"><i class="icon_wx" @click="wxLogins"></i></p>
                   </div>
                </div>
            </div>
       </section>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex"
import { getCheckCode, phoneLogin, authQuery } from "../assets/js/getData"
import { setStore, Validate, getTimeStamp, uuid } from '../assets/js/utils'
import { baseUrl } from '../assets/js/env'

export default {
  components:{},
  props:{},
  data(){
    return {
      countTime: 30,
      countTimeName: '获取验证码', //验证码文案
      imgVerify: '', //图片验证码(图片)
      msgSend: false,//错误提示
      errorPhone: false,
      errorPic: false,
      errorMsg: false,
      phoneNumber: '',//基础参数
      imgCode: '',
      msgcode: '',
      newTab: null, //第三方登录
      queryLoop: null
    }
  },
  watch:{},
  computed:{
    verImgCode(){
      return Validate.isImgCode(this.imgCode)
    },
    verMsgCode(){
      return Validate.isMsgCode(this.msgcode)
    }
  },
  methods:{
    ...mapMutations('user',[
        "SAVE_USERINFO",
        "OUT_LOGIN",
        "LoginPanelStatus_Show",
        "LoginPanelStatus_Hide"
    ]),
    // 关闭login
    closeLoginPanel(){
      if(this.queryLoop) {
        clearInterval(this.queryLoop)
      }
      this.LoginPanelStatus_Hide()
    },
    //改变边框
    removeBorder(type){
        switch(type) {
           case 'phone':
           this.errorPhone = false
           break;
           case 'pic':
           this.errorPic = false
           break; 
           case 'msg':
           this.errorMsg = false
           break;   
        }
    },
    //获取图形验证码
    getVerifyImg() {
      this.imgVerify = `${baseUrl}/v1/captcha?uuid=${uuid()}&time=${getTimeStamp()}`
    },
    //获取短信验证码
    getMsgCodes() {
        if(!Validate.isMobile(this.phoneNumber)) {
            this.errorPhone = true
            this.systemTips('error', '手机号格式错误')
            return
        }
        if(!Validate.isImgCode(this.imgCode)) {
            this.errorPic = true
            this.systemTips('error', '图形验证码错误')
            return
        }
      if(this.countTime == 30) {
        getCheckCode(this.phoneNumber, this.imgCode).then((data)=>{
            if(data.data.code === 0) {
              this.systemTips('success', "短信已发送")
              this.msgSend = true
              setTimeout(()=>{
                  this.msgSend = false;
              }, 3000)
              let countDowns = setInterval(()=>{
                  if( this.countTime > 0 ){
                    this.countTime = this.countTime-1
                    this.countTimeName = `重新获取(${this.countTime}s)`
                  }else{
                    clearInterval(countDowns)
                    this.countTimeName = '获取验证码'
                    this.countTime = 30
                  }
              }, 1000)
            }else{
              this.systemTips('error', data.data.message)
            }
          })
      }
    },
    //登录
    toLogin() {
        if(!Validate.isMobile(this.phoneNumber)) {
            this.errorPhone = true
            this.systemTips('error', '手机号格式错误')
            return
        }
        if(!Validate.isImgCode(this.imgCode)) {
            this.errorPic = true
            this.systemTips('error', '图形验证码错误')
            return
        }
        if(!Validate.isMsgCode(this.msgcode)) {
            this.errorMsg = true 
            this.systemTips('error', '短信验证码错误')
            return
        }
        phoneLogin(this.phoneNumber, this.msgcode).then((data)=>{
           if(data.data.code === 0) {
             this.saveUserInfos(data.data)
           }else{
             this.systemTips('error', data.data.message)
           }
        })
    },
    //第三方登录--qq
    qqLogins() {
      let uuids = "qq_" + uuid(),
      qq_conf = {
        appid: "101430090",
        redirect_uri: encodeURIComponent("http://draw.liuchengtu.net/user.html#/user_auth?type=3&source=101&client=user_center")
      }
      if(this.queryLoop) {
        clearInterval(this.queryLoop)
      }
      this.newTab = window.open('', 'qq_auth')
      this.newTab.location = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=${qq_conf.appid}&redirect_uri=${qq_conf.redirect_uri}&state=${uuids}`
      this.pollLoginResult(uuids)
    },
    //第三方登录--wx 
    wxLogins() {
        let uuids = "wx_" + uuid(),
        weixin_conf = {
          appid: "wx4978e9746f6bf7e5",
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent("http://draw.liuchengtu.net/user.html#/user_auth?type=2&source=101&client=user_center")
        }
        if(this.queryLoop) {
          clearInterval(this.queryLoop)
        }
        this.newTab = window.open('', 'wx_auth')
        this.newTab.location = `https://open.weixin.qq.com/connect/qrconnect?appid=${weixin_conf.appid}&redirect_uri=${weixin_conf.redirect_uri}&response_type=code&scope=snsapi_login&state=${uuids}#wechat_redirect`
        this.pollLoginResult(uuids)
    },
    // 获取第三方登录结果
    async pollLoginResult(type) {
        this.queryLoop = setInterval(()=>{
          authQuery(type).then((res)=>{
            if(res.data.code === 0) {
              clearInterval(this.queryLoop)
              this.saveUserInfos(res.data)
            }else{
              console.log(res.data.message)
            }  
          })  
        }, 2000)
        
    },
    //存储用户信息
    saveUserInfos(res) {
      this.LoginPanelStatus_Hide()
      setStore("token", res.data.token)
      setStore("picture", res.data.user.picture)

      setStore("vip", res.data.user.vips || 'nothing')
      res.data.user.nick_name ? setStore("nick_name", res.data.user.nick_name) : setStore("nick_name", res.data.user.phone)
      this.SAVE_USERINFO(res.data.user)
    },
    //消息提醒
    systemTips(type, txt){
      this.$notify({
        message: txt,
        type: type,
        position: 'bottom-right',
        duration: 2000
      });
    } 
  },
  created(){
     this.getVerifyImg()
  },
  mounted(){
       
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/css/common";

.login{
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  z-index: 1000;
  .login_panel{
      width: 324px;
      height: 425px;
      background-color: $colorff;
      border-radius: 3px;
      margin-left: 50%;
      position: relative;
      top: 50%;
      transform: translate(-160px, -225px);
      text-align: center;
      .login_panel_close{
        position: absolute;
        top: 0;
        right: -25px;
        @include icon(20px, 20px, top);
        background: url("../assets/image/logins/ico_guanbi.png");
      }
      nav{
        width: 100%;
        .nav-line{
          height: 5px;
          background:linear-gradient(90deg,rgba(0,144,255,1),rgba(4,163,255,1));
        }
        .nav-fonts{
          margin-top: 27px;
          margin-left: 27px;
          color: $color060;
          @include font(16px, 400);
          text-align: left;
        }
       
      }
      .login_content{
        .login_tophone{
            .inputError{
              border-color: #EE631F;
            }
            .inputNormal{
              border-color: rgba(201,212,224,1);
            } 
            .login_input{
              height: 35px;
              line-height: 35px;
              margin-left: 27px;
              margin-right: 27px;
              border-style: solid;
              border-width: 1px;
              border-radius:3px;
              display: flex;
              position: relative;
              box-sizing: border-box;
              span{
                margin-top: 6px;
                margin-left: 6px;
              }
              input{
                height: 33px;
                color:rgba(76,76,76,1);
                @include font(12px, 400);
                flex: 1;
                margin-left: 6px;
                padding-left: 8px;
                &::-webkit-input-placeholder{
                  color:rgba(76,76,76,1);
                   @include font(12px, 400);
                }
                background:none;  
                outline:none;  
                border:0px;
                border-left: 1px solid rgba(201,212,224,1);
              }
            }
            .login_input2{
               margin-left: 27px;
               margin-right: 27px;
               display: flex;
               overflow: hidden;
              .inputError{
                border-color: #EE631F;
              }
              .inputNormal{
                border-color: rgba(201,212,224,1);
              }  
              .inputs{
                width: 162px;
                height: 35px;
                border-radius:3px;
                border-style: solid;
                border-width: 1px;
                display: flex;
                justify-content: space-between;
                position: relative;
                box-sizing: border-box;
                margin-right: 13px;
                span{
                  margin-top: 6px;
                  margin-left: 6px;
                  flex-shrink:0;
                }
                input{
                  height: 33px;
                  color:rgba(76,76,76,1);
                  @include font(12px, 400);
                  flex: 1;
                  margin-left: 6px;
                  padding-left: 8px;
                  &::-webkit-input-placeholder{
                    color:rgba(76,76,76,1);
                    @include font(12px, 400);
                  }
                  background:none;  
                  outline:none;  
                  border:0px;
                  border-left: 1px solid rgba(201,212,224,1);
                }

              }
              .code_inputs{
                 width: 96px;
                 height: 35px;
                 display: inline-block;
                 line-height: 35px;
                 text-align: center;
                 border-radius:3px;
              }
              .code_img{
                border: 1px solid #D1DEEB;
                box-sizing: border-box;
              }
              .msg_code{
                @include font(12px , 400);
                color: #0090FF;
                border:1px solid #0090FF;
              }

            } 
            .login_loginbtn{
              display: inline-block;
              text-align: center;
              line-height: 38px;
              width:272px;
              height:38px;
              background:rgba(0,144,255,1);
              border:1px solid rgba(0,126,223,1);
              border-radius:3px;
              text-align: center;
              @include font(14px, 400);
              color: $colorff;
            }
            .login_otherway{
                .other_way_line{
                   display: flex;
                   justify-content: center;
                   align-items: center;
                   .line{
                      width: 73px;
                      height: 1px;
                      display: inline-block;
                      background: #EBEBEB;
                   }
                   .name{
                      @include font(12px, 400);
                      color: #4C4C4C;
                      margin: 0 17px;
                   }
                }
                .other_way{
                  display: flex;
                  justify-content: center;
                  p{
                    @include font(14px, 400);
                    color: $color99;
                    i{
                      margin-right: 10px;
                    }
                    &:nth-child(1){
                      margin-right: 59px;
                    }
                  }
                }

            }
        }

      }
  }
}
.icon_phone{
    @include icon(22px, 22px, top);
    background: url("../assets/image/logins/ico_shouji.png") no-repeat;
}
.icon_nopass{
    @include icon(22px, 22px, top);
    background: url("../assets/image/logins/ico_noyanz.png") no-repeat;
}
.icon_pass{
    @include icon(22px, 22px, top);
    background: url("../assets/image/logins/ico_yanz.png") no-repeat;
}

.icon_qq{
  @include icon(42px, 42px, middle);
  background: url("../assets/image/logins/btn_qq_01.png") no-repeat;
}
.icon_wx{
  @include icon(42px, 42px, middle);
  background: url("../assets/image/logins/btn_weix_01.png") no-repeat;
}

//new
.marginTop17{
  margin-top: 17px;
}
.marginTop19{
  margin-top: 19px;
}
.marginTop20{
  margin-top: 20px;
}
.marginTop22{
  margin-top: 22px;
}
.marginTop30{
  margin-top: 30px;
}
</style>
